export default "__VITE_ASSET__Bb0$9kA9__"